import VaultPaymentMethodImg from './assets/vault-payment-methods.png'
import ThreeDsImg from './assets/threeds.png'
import CustomizeUniversalCheckougImg from './assets/customize-universal-checkout.png'

export const featureGuides = [
	{
		title: 'Customize Universal Checkout',
		description: 'Style our drop-in checkout to blend seamlessly in with your website or mobile app.',
		link: './universal-checkout/drop-in/customize-checkout/',
		imgSrc: CustomizeUniversalCheckougImg,
	},
	{
		title: 'Trigger 3DS',
		// Comply with SCA in a unified way
		description: 'Authenticate online payments using an extra layer of security for customers.',
		link: './3ds',
		imgSrc: ThreeDsImg,
	},

	{
		title: 'Vault payment methods',
		description: 'Securely store your customers’ payment methods securely.',
		link: './save-payment-methods',
		imgSrc: VaultPaymentMethodImg,
	},
]
